
import React, { useEffect, useState, useCallback } from "react";
import { Box, Alert, Typography, Stack, useMediaQuery, Modal, Card } from "@mui/material";

import CalendarTile from "../widgets/CalendarTile/CalendarTile";
import withThisUser from "../../wrappers/withThisUser";
import getReservedTimeSlotsForUsers from "../helpers/getReservedTimeSlotsForUsers"
import { DataGrid } from '@mui/x-data-grid';
import formatTime from "../utilities/fromatTime";
import formatExamDate from "../utilities/formatExamDate";

import { getUsers } from "../helpers/requestUsers";
import SingleUserTile from "../widgets/SingleUserTile";
import CardTable from "../widgets/CardTable";



const Schedule = ({thisUserData}) => {

    const isMobile = useMediaQuery("(max-width:600px)");
    const [alert, setAlert] = useState("");
    const [reservations, setReservations] = useState(null);
    const [gridRows, setGridRows] = useState(null);
    const [reportOpen, setReportOpen] = useState(false);
    const toggleReportOpen = useCallback(() => {
    setReportOpen(prev => !prev);
    }, []);
    const [singleUserData, setSingleUserData] = useState([]);

    useEffect(() => {
        getReservedTimeSlotsForUsers([thisUserData.userId], setReservations)
    }, [thisUserData.userId, alert])

    useEffect(() => {
        if (reservations) {
            setGridRows(reservations['data'][thisUserData.userId.toString()]);
        }
    },[reservations, thisUserData.userId]);

    const paginationModel = { page: 0, pageSize: 10 };
    const gridColumns = [
        { flex: 0.5, headerName: 'ID', field: 'id'},
        { flex: 1, headerName: 'Date', field: 'exam_date', renderCell: (params) => <span>{formatExamDate(params.row.exam_date)}</span>},
        { flex: 1, headerName: 'Start', field: 'start_time', renderCell: (params) => <span>{formatTime(params.row.start_time)}</span> },
        { flex: 1, headerName: 'End', field: 'end_time', renderCell: (params) => <span>{formatTime(params.row.end_time)}</span> },
        { flex: 1, headerName: 'Components', field: 'component_type', renderCell: (params) => <span>{params.row.component_type}</span> },
        { flex: 1, headerName: 'Notes', field: 'notes', renderCell: (params) => <span>{params.row.notes}</span> },
    ];

    const gridStyle = {mt:1, mb:2, borderRadius:4, cursor:'pointer', width:'100%'}
    
    const bigStyling = {maxWidth:'950px', width: '100%'};
    const mobileStyling = {maxWidth:'950px'};

    const handleRowClickTestersTable = (params) => {
        getUsers(params.row.test_taker, setSingleUserData);
    }

    useEffect(() => {
    if (singleUserData.length === 0) {
        return;
    } else {
        toggleReportOpen();
    }
    }, [singleUserData, toggleReportOpen])

    return (
        <Box sx={isMobile ? mobileStyling : bigStyling}>
            <Stack direction={'column'} sx={{}}>
                {thisUserData.userType !== 'district_admin' && (
                    <>
                        <Typography sx={{mb:1, color:'#054fb9', fontWeight:700}} variant="h4">
                        Schedule an Exam
                        </Typography>
                        <Typography sx={{mb:2, fontSize:16}} variant="p">
                            To schedule an exam, click on a blue highlighted date on the calendar below.  You can then reserve a time slot from the list of available time slots by clicking the blue "reserve" button.  You will then receive an email confirmation with important exam information.
                        </Typography>
                    </>
                )}

                <Stack direction={'row'} sx={{ mt:2, mb:2, alignItems:'center'}}>
                    <Box sx={{ml:1, mr:1, height:'26px', width:'26px', backgroundColor:'#4a91e264', display:'inline-block'}}></Box> 
                    <Typography sx={{mr: 2}}>Available Time Slot</Typography>
                    <Box sx={{ ml:1, mr:1, height: '26px', width: '26px', border: '4px solid #4a90e2', display:'inline-block' }}></Box>
                    <Typography>Today's Date</Typography>
                </Stack>
            </Stack>
            
            <CalendarTile 
                setAlert={setAlert} onRowClick={handleRowClickTestersTable}
            />

            <Modal
                open={reportOpen}
                onClose={toggleReportOpen}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <SingleUserTile user_data={singleUserData.id} modalView={true}/>
            </Modal>    

            {alert && <Alert sx={{mt:2}} severity={alert.status===201?'success':'error'} onClose={() => {setAlert('')}}>{alert.status===201?'Reserved Timeslot':alert.data.status}</Alert>}
            
            { reservations && (
                <>
                    <Stack direction={'column'} sx={{mt:2}}>
                        <Typography sx={{mt:4, mb:1, color:'#054fb9', fontWeight:700}} variant="h4">
                            Your Reserved Timeslots
                        </Typography>
                        <Typography sx={{mb:2, fontSize:16}} variant="p">
                            IMPORTANT: Check your email for confirmation of your reservation.  If you did not receive an email, please contact your district.
                        </Typography>
                    </Stack>

                    {!isMobile ? (
                        <DataGrid 
                            sx={gridStyle}
                            rows={gridRows}
                            columns={gridColumns}
                            initialState={{ 
                                pagination: { paginationModel },
                                columns: {
                                    columnVisibilityModel: {
                                        id: false,
                                    }
                                },
                            }}
                            disableRowSelectionOnClick
                            pageSizeOptions={[10, 30, 50, 100]}
                        /> 
                    ) : (
                        <CardTable 
                            rows={gridRows}
                            columns={gridColumns}
                            columnVisibilityModel={{id:false}}
                            sort={{key:'id', direction:'desc'}}
                            sx={{height:'40%', overflowY: 'scroll'}}
                        />
                    )} 

                </>
            )}
        </Box>
    )
};

export default withThisUser(Schedule);